// =============== Helpers ===============
export function clamp(n: number, min: number, max: number) {
  return Math.min(Math.max(n, min), max);
}

export function toFixedSafe(n: number, decimals: number) {
  const p = Math.pow(10, decimals);
  return Math.round(n * p) / p;
}

// Produces an array of characters for the price digits (without the currency sign)
export function priceToDigits(
  amount: number,
  opts?: { decimals?: number; minDigits?: number }
) {
  const decimals = opts?.decimals ?? 2;
  const minDigits = opts?.minDigits ?? 4;
  const fixed = toFixedSafe(amount, decimals).toFixed(decimals); // e.g. "25.20"
  const joined = fixed.replace(".", ""); // e.g. "2520"
  const digits = joined.split("");
  // left pad with zeros to guarantee minDigits
  while (digits.length < minDigits) digits.unshift("0");
  return digits;
}
